// src/api/http.js
// —————————————————————————————————————————
// Instancia centralizada de Axios.
// Todos los componentes importan desde aquí en lugar de
// copiar "http://localhost:3000" en cada archivo.
// Para cambiar de entorno, edita únicamente el archivo .env
// —————————————————————————————————————————
import axios from 'axios'
import router from '../router'
import { useSessionStore } from '../stores/session'

const http = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    withCredentials: true
})

// Interceptor para re-dirigir en caso de Error 401 (Token Vencido/Inválido)
http.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Limpia sesión global
            const sessionData = useSessionStore()
            sessionData.destroy()

            // Navegación suave del SPA 
            router.push('/login')
        }
        return Promise.reject(error)
    }
)

export default http
